import React, {Component} from 'react';
import ReactHtmlParser from 'react-html-parser';
import classNames from 'classnames';
import moment from 'moment';
import { Carousel } from 'react-responsive-carousel';
import YouTube from 'react-youtube';
import templateTypes from '../../../common/templateTypes';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

class ArticleViewPage extends React.Component {
    constructor(props) {
        super(props);
    }

    getPublishedInfo() {
        let article = this.props.article;
        let result = [];

        article.categories.forEach((category, key) => {
            result.push(<b key={key}>{category.name} | </b>)
        });

        if(article.contactPerson) {
            result.push(<span key="contactPerson">Af <a href={`mailto:${article.contactPerson.email}`}>{article.contactPerson.name}</a> | </span>);
        }

        result.push(moment(article.publishAt * 1000).format('lll'));

        return result;
    }

    getContent() {
        let article = this.props.article;
        let templateType = article.template !== undefined ? article.template.englishName : 'align top';
        let carousel = null;
        let content = null;

        if(templateType !== templateTypes.NO_PICTURES && article.images.length) {
            carousel = <Carousel
                showArrow={false}
                showStatus={false}
                showIndicators={false}
                showThumbs={false}
                dynamicHeight={true}
            >
                {
                    article.images.map(function (image, key) {
                        return <div key={key}>
                            <img src={image.path} />
                        </div>
                    })
                }
            </Carousel>;
        }

        switch(templateType) {
            case templateTypes.ALIGN_TOP:
                content = <div>
                    <div className="row mb-4">
                        <div className="col-12">
                            {carousel}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h3>{article.resume}</h3>
                            {ReactHtmlParser(article.description)}
                        </div>
                    </div>
                </div>;
                break;
            case templateTypes.ALIGN_LEFT:
                content = <div className="row">
                    <div className="col-12">
                        <h3>{article.resume}</h3>
                        <div className="pull-left width-40-pct mr-4">{carousel}</div>
                        {ReactHtmlParser(article.description)}
                    </div>
                </div>;
                break;
            case templateTypes.ALIGN_RIGHT:
                content = <div className="row">
                    <div className="col-12">
                        <h3>{article.resume}</h3>
                        <div className="pull-right width-40-pct ml-4">{carousel}</div>
                        {ReactHtmlParser(article.description)}
                    </div>
                </div>;
                break;
            case templateTypes.ALIGN_BOTTOM:
                content = <div className="mb-4">
                    <div className="row">
                        <div className="col-12">
                            <h3>{article.resume}</h3>
                            {ReactHtmlParser(article.description)}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12">
                            {carousel}
                        </div>
                    </div>
                </div>;
                break;
            case templateTypes.NO_PICTURES:
                content = <div className="row">
                    <div className="col-12">
                        <h3>{article.resume}</h3>
                        {ReactHtmlParser(article.description)}
                    </div>
                </div>;
                break;
        }


        return content
    }

    render() {
        let {
            article,
        } = this.props;

        return (
        <div className="row">
            <div className="col-12">
                <div className="card m-b-20">
                    <div className="card-block">
                        <article>
                            <header><h1>{article.heading}</h1></header>
                            <address>
                                <p className="mt-4">
                                    {this.getPublishedInfo()}
                                </p>
                            </address>
                            <hr/>
                            {this.getContent()}
                            <hr/>
                            {
                                article.youtubeId
                                    ?
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <div className="embed-responsive embed-responsive-16by9">
                                                <YouTube videoId={article.youtubeId}/>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                        </article>
                    </div>
                </div>
            </div>
        </div>
        );
    }
};

export default ArticleViewPage;


// WEBPACK FOOTER //
// ./web/src/components/articles/view/ArticleViewPage.jsx